const showTableById = (id) => {
  const tables = [...document.querySelectorAll('[data-table]')];
  const tableToShow = tables.filter((table) => table.dataset.table === id)[0];
  tables.forEach((table) => table.classList.add('hidden'));
  tableToShow.classList.remove('hidden');
};

export default showTableById;
